import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Divider, Rate, Row, Spin } from "antd";
import TrackCard from "../../components/track-card";
import {
  DollarOutlined,
  MoneyCollectOutlined,
  StarOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import TrackImage from "../../assets/track-overview.png";
import TrainerImage from "../../assets/trainer.png";
import ProfessionalCertificateImage from "../../assets/professional-certificate.png";

import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";
import { getCourseById } from "../../store/apis/courses";
import { getTrack } from "../../store/apis/tracks";

function TrackCourses() {
  const [loading, setLoading] = useState(true);
  const state = useSelector((state) => state);
  const trackState = useSelector((state) => state.tracks.track);
  const courseState = useSelector((state) => state?.courses?.trackCourses);
  const dispatch = useDispatch();

  useMemo(() => {
    const trackId = window.location.pathname.split("/")[2];
    if (trackId) {
      dispatch(getTrack(trackId));
    }
  }, []);

  useEffect(() => {
    if (!courseState?.length) {
      if (trackState?.trackcourses?.length) {
        for (let i = 0; i < trackState?.trackcourses.length; i++) {
          const element = trackState?.trackcourses[i];
          dispatch(getCourseById(element?.courseId));
        }
      }
    }
  }, [trackState?.trackcourses?.length]);

  useMemo(() => {
    setTimeout(() => {
      if (courseState) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    }, 1000);
  }, [courseState]);

  const renderCoursesTrack = () => {
    let trackcourses;
    if (trackState?.trackcourses) {
      trackcourses = trackState?.trackcourses;
    }
    return (
      <div className="courses-track-container">
        <div className="courses-track-section-title">
          <h2>هناك {courseState?.length} دورات في هذه الشهادة المهنية</h2>
        </div>
        {courseState?.map((item, index) => {
          return (
            <div className="course-step" key={item.courseStep}>
              <a href={`/course/${item?._id}`}>
                <Row>
                  <Col
                    xs={24}
                    sm={24}
                    md={2}
                    lg={2}
                    xl={2}
                    className="courses-track-description-ant-Col"
                  >
                    <div className="courses-track-title">
                      <p> الكورس </p>
                      <span> {index + 1} </span>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                    <div className="courses-track-description">
                      <h3> {item?.title} </h3>
                      <div className="rate-desc">
                        <Rate disabled value={item?.courseRating} />
                        <p>
                          {item?.courseRating} نجوم <br />
                        </p>
                      </div>
                      <p>{item?.description}</p>
                    </div>
                  </Col>
                </Row>
              </a>
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <div>
      {!loading ? renderCoursesTrack() : <Loader />}
      {!courseState && <div> NO COURSES FOR THIS TRACK !!! </div>}
    </div>
  );
}

export default TrackCourses;
